import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { MaterialAsphaltProduct } from '@src/types/MaterialAsphaltProduct'
import { TransportTypeId } from '@src/types/TransportTypeId'

interface Options  {
  srrId: number | string,
  serialId: number,
  transportTypeId: TransportTypeId,
  partial: Partial<MaterialAsphaltProduct>,
}

export const apiSrrTransportCreate = (options: Options) => {
  const { 
    srrId, 
    serialId,
    transportTypeId,
    partial,
  } = options

  const data = {
    srrId,
    transportType: {
      id: transportTypeId,
    },
    ...partial,
  }
  const axOptions = {
    method: 'POST',
    url: `${BASE_API_URL}/v2/srr/${srrId}/machine/transport/details/${srrId}`,
    data,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}